import { TGoal } from 'components/molecules/HealthGoalSelection/HealthGoalSelection';

const HEALTH_GOAL_DISPLAY_STATUS = {
	pregnant: 'pregnant',
	underweight: 'underweight',
	calculateBmi: 'calculateBmi',
} as const;

type THealthGoalDisplayStatus = keyof typeof HEALTH_GOAL_DISPLAY_STATUS;

interface IOptions {
	isPregnant?: boolean;
	bmiValue: number;
	selectedGoal?: TGoal;
}

export function getHealthGoalDisplayStatus({
	isPregnant,
	bmiValue,
	selectedGoal,
}: IOptions): THealthGoalDisplayStatus | undefined {
	if (selectedGoal === 'healthier') {
		return;
	}

	if (isPregnant) {
		return HEALTH_GOAL_DISPLAY_STATUS.pregnant;
	}

	if (bmiValue <= 18.5) {
		return HEALTH_GOAL_DISPLAY_STATUS.underweight;
	}

	if (selectedGoal === 'fruits') {
		return HEALTH_GOAL_DISPLAY_STATUS.calculateBmi;
	}

	return;
}
